import { ReactNode } from 'react';
import { Fab, FabProps, SxProps, Theme } from '@mui/material';

import { sxStyles } from './CoreIconButton.styles';

export interface CoreIconButtonProps {
  className?: string;
  onClick?: () => void;
  size?: FabProps['size'];
  color?: 'primary' | 'secondary';
  variant?: 'circular';
  ariaLabel?: string;
  href?: string;
  sx?: SxProps<Theme>;
  children?: ReactNode;
}

export const CoreIconButton = ({
  variant = 'circular',
  className,
  onClick,
  color = 'primary',
  size = 'small',
  ariaLabel,
  href,
  sx,
  children,
}: CoreIconButtonProps) => (
  <Fab
    {...{ size, color, className, href, variant, onClick }}
    aria-label={ariaLabel}
    sx={[sxStyles.fab, ...(Array.isArray(sx) ? sx : [sx])]}
  >
    {children}
  </Fab>
);
